import { useEffect, useState } from "react";
import ParticipantDetailsCard from "./ParticipantDetailsCard";
import { ParticipantProfile } from "../../../models/entities/participant.model";
import { Form } from "react-final-form";
import ParticipantDetailsField from "./ParticipantDetailsField";
import FormUiInputSwitch from "../../../components/input-switch/InputSwitch.component";
import { FormApi } from "final-form";
import { PtDetailsMode } from "../../../models/pages/participant-details/participant-details.model";
import { Roles } from "../../../models/roles.model";
import { MarketingCampaignForm } from "../../../models/pages/participant-details/marketing-info.model";
import { MarketingCampaign } from "../../../models/entities/marketing-campaign.model";
import { useMarketingCampaigns } from "../../../hooks/useMarketingCampaigns";
import { Formatter } from "../../../services/formatter/formatter.service";
import { useUpdateMarketingCampaigns } from "../../../hooks/useUpdateMarketingCampaign";

const MarketingCampaigns = ({ participant }: { participant: ParticipantProfile }) => {
	const campaigns = useMarketingCampaigns(participant.id);
	const updateCampaigns = useUpdateMarketingCampaigns();
	const [mode, setMode] = useState<PtDetailsMode>(PtDetailsMode.READ);
	const [showError, setShowError] = useState<boolean>(false);
	const [formData, setFormData] = useState<MarketingCampaignForm>();
	const [initialData, setInitialData] = useState<MarketingCampaignForm | undefined>();

	useEffect(() => {
		if (campaigns.data) {
			setInitialData(new MarketingCampaignForm(campaigns.data));
			setFormData(new MarketingCampaignForm(campaigns.data));
		}
	}, [campaigns.data]);

	const hasChanges = () => {
		if (!formData || !campaigns.data) return false;
		return formData.campaigns.some(
			(item) =>
				item.paused !=
				initialData?.campaigns.find((i: MarketingCampaign) => i.name === item.name)?.paused
		);
	};

	const handleSubmit = async (
		data: MarketingCampaignForm,
		form: FormApi<MarketingCampaignForm, Partial<MarketingCampaignForm>>
	) => {
		setShowError(false);
		// Replace with an existing method or implement postCampaignPausedStatusForPatient in EndpointsService.dataRetriever
		// Example using a generic update method (replace with the correct one for your API):
		await updateCampaigns
			.mutateAsync({
				patientId: participant.id,
				campaigns: data.campaigns,
				initialData: initialData,
			})
			.then(async () => {
				// Update form state
				form.reset();
				setMode(PtDetailsMode.READ);
				await campaigns.invalidate(); // Refresh the campaigns data
			}) // Handle success
			.catch(() => setShowError(true));
	};

	console.log("MarketingCampaigns rendered with formData:", formData);
	return (
		<Form
			onSubmit={handleSubmit}
			initialValues={formData}
			render={({ handleSubmit, form, submitting }) => (
				<form onSubmit={handleSubmit}>
					<ParticipantDetailsCard
						title="PARTICIPANT.DETAILS.MARKETING_CAMPAIGNS.TITLE"
						submitting={submitting}
						mode={mode}
						enableEditing={!Roles.isProvider()}
						showError={showError}
						enableSubmit={hasChanges()}
						onCancel={() => {
							form.reset();
							setShowError(false);
							setFormData(initialData);
							setMode(PtDetailsMode.READ);
						}}
						onModeChange={() => setMode(PtDetailsMode.UPDATE)}
					>
						<div className="">
							<ParticipantDetailsField
								value={
									formData?.campaigns &&
									formData.campaigns.map((item) => (
										<FormUiInputSwitch
											id={item.name}
											key={item.name}
											label={Formatter.beautifyString(item.name)}
											name={item.name}
											checked={!item.paused}
											onChange={(e) =>
												setFormData({
													...formData,
													campaigns: formData.campaigns.map((c) =>
														c.name === item.name
															? { ...c, paused: !e.value }
															: c
													),
												})
											}
											disabled={mode === PtDetailsMode.READ}
										/>
									))
								}
							/>
						</div>
					</ParticipantDetailsCard>
				</form>
			)}
		/>
	);
};

export default MarketingCampaigns;
